import React, { useRef, useState, useEffect } from "react";
import ImageMapper from "react-img-mapper";

import json from "../data.json";
import image from '../assets/rokbak_map_final.jpg';
import Modal from './Modal';
import Icon from './Icon';

const Mapper = props => {
  const myRef = useRef(null);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [dimensions, setDimensions] = useState({ 
    height: document.querySelector('#root').offsetHeight,
    width: document.querySelector('#root').offsetWidth
  })
  const [width, setWidth] = useState(0)
  useEffect(() => {
    window.addEventListener('resize', handleResize);
  }, [])

  const IMAGE = String(image)
  const MAP = {
    name: "my-map",
    areas: json
  };

  const handleResize = () => {
    setDimensions({
      height: document.querySelector('#root').offsetHeight,
      width: document.querySelector('#root').offsetWidth    
    })
  }

  const drawPoly = (
    coords,
    fillColor,
    lineWidth,
    strokeColor,
    ctx,
    canvas
  ) => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = 'source-over'
    ctx.fillStyle = fillColor
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = "destination-out";
    const newCoords = coords.reduce((a, v, i, s) => (i % 2 ? a : [...a, s.slice(i, i + 2)]), []);
    ctx.beginPath();
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = strokeColor;
    newCoords.forEach(c =>ctx.lineTo(c[0], c[1]));
    ctx.closePath();
    ctx.fill();
  };
  
  const tintWindow = (props) => {
    const {scaledCoords} = props 
    const canvas = document.getElementsByClassName('img-mapper-canvas')[0]
    canvas.height = document.getElementsByClassName('img-mapper-img')[0].offsetHeight
    
    drawPoly(scaledCoords,'#ffffff99',  1, 'black', canvas.getContext('2d'), canvas)

    canvas.classList.add("opacity--in")
  }

  const toggleModal = (props) => {
    setModal(!modal);
    if (props) {
      setModalData(props)
    }
  };

  const prevModalContext = () => {
    const index = json.findIndex(e => e.id === modalData.id)
    setModalData(json[index === 0 ? json.length - 1 : index - 1])
  }

  const nextModalContext = () => {
    const index = json.findIndex(e => e.id === modalData.id)
    setModalData(json[json.length === index + 1 ? 0 : index + 1])
  }

  const scaleCoords = ({ coords = [], imgWidth, naturalWidth }) => {
    return coords.map(coord => coord * (imgWidth / naturalWidth))
  };

  const imageDimensions = file =>
  new Promise((resolve, reject) => {

    if (!file) {
      resolve({ height: 0, width: 0 })
    }
    const img = new Image()
    // the following handler will fire after a successful loading of the image
    img.onload = () => {
      const { naturalWidth: width, naturalHeight: height } = img
      resolve({ width, height })
    }
    // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
    img.onerror = () => {
      reject('There was some problem with the image.')
    }

    img.src = file
  })

  imageDimensions(IMAGE).then(res => setWidth(res.width))

  return (
    <>
    <div className="layout-item-full-width mapper">
      <div className="icons">
        {json.map(({iconCoords}, index) => 
          <Icon
            key={index}
            img={IMAGE} 
            imgWidth={dimensions.width} 
            coords={iconCoords}
            content={json[index]}
            tintWindow={tintWindow}
            toggleModal={toggleModal}
          />
        )}
      </div>
      <ImageMapper
        containerRef={myRef}
        src={IMAGE}
        map={MAP}
        stayMultiHighlighted
        parentWidth={dimensions.width}
        responsive={true}
        imgWidth={dimensions.width}
      />
    </div>
      <Modal 
        enabled={modal}
        toggleModal={toggleModal}
        modalData={modalData}
        prevModalContext={prevModalContext}
        nextModalContext={nextModalContext}
        hasNavigation={false}
      />
    </>
  );
};

export default Mapper;
